import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer as SC } from 'react-sortable-hoc';

const SortableContainer = SC(props => (
  <div className={`sortablehoc ${props.containerClass ? props.containerClass : ''}`}>
    {props.headerNode ? props.headerNode : ''}
    {
      // eslint-disable-next-line no-nested-ternary
      props.data.length > 0 ? props.data.map((value, index) => (
        props.item ? props.item({
          index,
          idx: index,
          key: `item-${index}`,
          value,
          ...props,
        }) : ''
      )) : (props.notFound ? props.notFound : '')
    }
    {props.footerNode ? props.footerNode : ''}
  </div>
));

SortableContainer.propTypes = {
  containerClass: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.array]).isRequired,
  footerNode: PropTypes.node,
  headerNode: PropTypes.node,
  notFound: PropTypes.node,
};

export default SortableContainer;



// WEBPACK FOOTER //
// ./src/components/Sortable/SortableContainer.jsx